import { z, uuidSchema } from '@kc3/validation';
import { baseEventFields } from './_base.js';
import { AgentStatusSchema } from '../enums/index.js';
export const AgentStateEventSchema = z.object({
    type: z.literal('agent.state'),
    ...baseEventFields,
    agentId: uuidSchema,
    previousStatus: AgentStatusSchema,
    status: AgentStatusSchema,
    reason: z.string().optional(),
    /**
     * Set when a supervisor forced the transition (force_pause / force_logout)
     * rather than the agent initiating it. Lets subscribers distinguish "you
     * clicked Pause" from "someone paused you" — the web client surfaces the
     * latter as a warning notification.
     */
    forced: z.boolean().optional(),
});
export const AgentPresenceEventSchema = z.object({
    type: z.literal('agent.presence'),
    ...baseEventFields,
    agentId: uuidSchema,
    online: z.boolean(),
    nodeId: z.string().min(1),
});
export const AgentWrapUpEndEventSchema = z.object({
    type: z.literal('agent.wrap_up_end'),
    ...baseEventFields,
    agentId: uuidSchema,
    wrapUpDurationMs: z.number().int().nonnegative(),
});
export const AgentOfferingEventSchema = z.object({
    type: z.literal('agent.offering'),
    ...baseEventFields,
    agentId: uuidSchema,
    callId: uuidSchema,
    queueId: z.string().min(1),
    offeredAt: z.string().datetime(),
});
export const AgentStatusChangedEventSchema = z.object({
    type: z.literal('agent.status_changed'),
    ...baseEventFields,
    agentId: uuidSchema,
    previousStatus: AgentStatusSchema,
    newStatus: AgentStatusSchema,
    reason: z.string().optional(),
});
//# sourceMappingURL=agent.js.map